import React, {FC, ReactElement, useEffect, useState} from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {companyApi} from "../../backend/CompanyApi";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {GetCompanyInfoDto} from "../../model/company/GetCompanySettingsDto";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import CountrySelector from "../../components/selector/CountrySelector";
import {Trans, useTranslation} from "react-i18next";

interface IProps {

}

export const MyCompanyInfo: FC<IProps> = (): ReactElement => {
    const [info, setInfo] = useState<GetCompanyInfoDto>()

    useEffect(() => {
        companyApi.fetchInfo(selectedCompanyStore.companyId)
                .then(setInfo)
    }, [])

    const {t} = useTranslation();

    const buildLine = (name: string, value?: string) => {
        return <>
            <Grid item container xs={12}>
                <Grid item xs={4} sm={3} md={2} lg={2}><Typography variant="subtitle2">{t(`my_company_info.${name}`, name)}</Typography></Grid>
                <Grid item xs={8} sm={9} md={10} lg={10}><Typography variant="body2">{value}</Typography></Grid>
            </Grid>
        </>
    }

    const registrationData = info?.registrationData;
    const legalAddress = [registrationData?.address, registrationData?.city, registrationData?.postalCode, CountrySelector.findByCode(registrationData?.countryCode)?.name]
            .filter(it => it)
            .join(", ");

    const nolaMailingAddress = legalAddress && legalAddress.toLowerCase().includes("ehitajate tee 110")

    return <>
        <LoaderWithCompanySelected loading={!info}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        <Trans i18nKey="my_company_info.header">
                            General info about your company
                        </Trans>
                    </Typography>
                </Grid>
                {buildLine("Company name", info?.name)}
                {buildLine("Reg. code", registrationData?.regCode)}
                {registrationData?.vatNumber && buildLine("VAT number", info?.registrationData?.vatNumber)}
                {legalAddress && buildLine("Legal address", legalAddress)}
                {nolaMailingAddress && <>
                    <Grid item xs={12}/>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            <b>
                                <Trans i18nKey="my_company_info.mailbox_address_note">
                                    If you would like to receive correspondence on behalf of your company please use the mailbox address below
                                </Trans>
                            </b>
                        </Typography>
                    </Grid>
                    {buildLine("Mailbox address", "Ehitajate tee 110-36, Tallinn, 13517, Estonia")}
                </>}
            </Grid>
        </LoaderWithCompanySelected>
    </>;
};